export default function(parent) {
  var self = this;
  self.courseworkTemplates = ko.observableArray();
  self.templatePaginator = ko.observable();
  self.selectedTemplate = ko.computed({
    read: function() {
      return parent && parent.coursework().template_id ? parent.coursework().template_id() : undefined;
    },
    write: function(value) {
      if (parent.coursework().id() == null) {
        parent.coursework().template_id(value);
      } else {
        new Kadenze.Notice.error({ message: 'Sorry, template can\'t be changed once the coursework has been created.' });
        self.selectedTemplate.notifySubscribers();
      }
    }
  });
  self.selectedSort = ko.observable();
  self.searchQuery = ko.observable();

  self.sortOptions = ko.observableArray([
    { id: 1, name: 'Created At Ascending', param: 'created_at', direction: 'asc'  },
    { id: 2, name: 'Created At Descending', param: 'created_at', direction: 'desc'  },
    { id: 3, name: 'Name Ascending', param: 'name', direction: 'asc' },
    { id: 4, name: 'Name Descending', param: 'name', direction: 'desc' }
  ]);

  self.bindData = function(data) {
    var mapped_templates = ko.mapping.fromJS(data.templates);
    self.courseworkTemplates(mapped_templates());

    self.templatePaginator(data.template_paginator);
  };

  self.initUI = function() {
    self.templateListing();

    $('#courseworkSearch').on('keypress', function(event) {
      var keycode = (event.keyCode ? event.keyCode : event.which);
      if(keycode == '13') {
        $('#courseworkSearch').blur();
        self.filterChanged();
      }
    });
  };

  self.bindPaginationEvents = function() {
    var $page_number = $('.page_number'),
      total_pages = parseInt($('.total_pages').text()),
      current_page = parseInt($('.current_page').text());

    $page_number.keyup(function(e){
      if(e.keyCode == 13){
        changePage($(this).val());
      }
    });
    $page_number.blur(function(e){
      changePage($(this).val());
    });

    $('.pagination a').off('click');
    $('.pagination a').on('click', function() {
      var url = $(this).attr('href');
      if (url != '#') {
        self.templateListing(url);
      }
      return false;
    });

    var changePage = function(pageNumber){
      if (parseInt(pageNumber)) {
        var destination_page = (pageNumber <= total_pages) ? pageNumber : total_pages;
        var url = Kadenze.Routes.coursework_templates_path() + '?page=' + destination_page;
        self.templateListing(url);
      } else {
        $page_number.val(current_page);
      }
    };
  };

  /*----------------------------------------COURSEWORK SEARCH/FILTERING FUNCTIONS-------------------------------------*/

  self.templateListing = function (url, params) {
    var request,
      requestUrl = url ? url : Kadenze.Routes.coursework_templates_path();

    request = new Kadenze.AjaxRequest({
      type: 'GET',
      dataAsJSON: false,
      url: requestUrl,
      data: params,
      loadingIndicator: {
        container: self.$el
      }
    });

    request.done(function(data) {
      self.bindData(data);
      self.bindPaginationEvents();
      Kadenze.Layout.update(); // Helps reset the footer / sidebar when there's dramatic changes in the course list lengths
    });

    request.fail(function(data) {
      console.warn('Failed to get courses: ', data);
      new Kadenze.Notice.error({ message: Kadenze.I18n.t('notice.unexpected_error') });
    });
  };

  self.filterChanged = function () {
    var sortOption = self.getSort(self.selectedSort()),
      sortParam = sortOption ? sortOption.param : '',
      sortDirection = sortOption ? sortOption.direction: '',
      params = {
        sort: sortParam,
        direction: sortDirection,
        q: self.searchQuery()
      };

    self.templateListing(null, $.param(params));
  };

  self.selectedSort.subscribe(self.filterChanged);

  self.getSort = function(id) {
    return _.find(self.sortOptions(), function(option) { return option.id === id; });
  };

  const __construct = function(that) {
    console.log('constructor called for InstructorFormTemplatesViewModel');
  }(this);
}

